const CLOSED = new Set(['SENT', 'CANCELLED', 'RETURNED']);
export const PRODUCT_STATUS_LABELS = {
  UNDEFINED: 'Не визначено',
  WILL_BE_ORDERED: 'Буде замовлено',
  ORDERED: 'Замовлено',
  OUT_OF_STOCK: 'Відсутній у постачальника',
  DO_NOT_DELIVERED: 'Не приїхав',
  NOT_SHIPPED: 'Не відвантажений',
  IN_STOCK: 'На складі',
};
export const ORDER_STATUS_LABELS = {
  NEW: 'Нове',
  HOLD: 'Відкладено',
  PREORDER: 'Передзамовлення',
  PREORDER_DELIVERY_CONFIRMED: 'Доставку підтверджено',
  PREORDER_AWAITING_SHIPMENT_CONFIRM: 'Очікує підтвердження відправки',
  WAITING_FOR_PACKAGING: 'Очікує на пакування',
  WAITING_FOR_SENDING: 'Очікує на відправлення',
};
const count = value => Math.max(0, Number(value) || 0);
const dateKey = value =>
  Array.isArray(value)
    ? value.map(part => String(part).padStart(2, '0')).join('-')
    : String(value || '');

export function groupProcurementDemand(lines, { search = '', status = '', sort = 'oldest' } = {}) {
  const query = search.trim().toLocaleLowerCase('uk');
  const groups = new Map();
  (lines || []).forEach(line => {
    if (CLOSED.has(line.orderStatus) || line.productStatus === 'RETURNED') return;
    const missing = count(line.quantity) - count(line.stockReservedQuantity);
    if (missing <= 0 || (status && line.productStatus !== status)) return;
    const searchable = [
      line.productName,
      line.parentProductName,
      line.productCode,
      line.productId,
      line.orderId,
    ]
      .join(' ')
      .toLocaleLowerCase('uk');
    if (query && !searchable.includes(query)) return;
    if (!groups.has(line.productId))
      groups.set(line.productId, {
        productId: line.productId,
        productCode: line.productCode,
        productName: line.productName,
        parentProductName: line.parentProductName,
        freeStockQuantity: count(line.freeStockQuantity),
        stockNeedsReview: Number(line.freeStockQuantity) < 0,
        missingQuantity: 0,
        orderedQuantity: 0,
        oldestOrderDate: dateKey(line.orderCreatedAt),
        orders: [],
      });
    const group = groups.get(line.productId);
    group.missingQuantity += missing;
    if (line.productStatus === 'ORDERED') group.orderedQuantity += missing;
    const created = dateKey(line.orderCreatedAt);
    if (created < group.oldestOrderDate) group.oldestOrderDate = created;
    group.orders.push({ ...line, missingQuantity: missing });
  });
  const result = Array.from(groups.values()).map(group => ({
    ...group,
    warehouseShortage: Math.max(0, group.missingQuantity - group.freeStockQuantity),
    quantityToOrder: Math.max(
      0,
      group.missingQuantity -
        group.orderedQuantity -
        group.freeStockQuantity,
    ),
    orders: group.orders.sort(
      (a, b) =>
        dateKey(a.orderCreatedAt).localeCompare(dateKey(b.orderCreatedAt)) || a.orderId - b.orderId,
    ),
  }));
  return result.sort((a, b) => {
    if (sort === 'quantity')
      return b.missingQuantity - a.missingQuantity || a.productId - b.productId;
    if (sort === 'name')
      return (
        (a.productName || '').localeCompare(b.productName || '', 'uk') || a.productId - b.productId
      );
    return a.oldestOrderDate.localeCompare(b.oldestOrderDate) || a.productId - b.productId;
  });
}

export function procurementTotals(groups) {
  const orders = new Set();
  const totals = { products: groups.length, orders: 0, missing: 0, toOrder: 0 };
  groups.forEach(group => {
    group.orders.forEach(order => orders.add(order.orderId));
    totals.missing += group.missingQuantity;
    totals.toOrder += group.quantityToOrder;
  });
  totals.orders = orders.size;
  return totals;
}
